import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&.MuiTableRow-root:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.focus,
  },
  '&.MuiTableRow-hover:nth-of-type(odd):hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.MuiTableRow-root:not(:last-child) td, &.MuiTableRow-root:not(:last-child) th': { border: 0 }
}));
